import { render, staticRenderFns } from "./BdTableWechat.vue?vue&type=template&id=786609c8&scoped=true&"
import script from "./BdTableWechat.vue?vue&type=script&lang=js&"
export * from "./BdTableWechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786609c8",
  null
  
)

export default component.exports